import { RoomUser } from '../../transport.interface';

export class SaveUserAction {
  static readonly type = '[User] Save';

  constructor(public payload: RoomUser | null) {
  }
}
